import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f149afa")

import {computed, watch} from 'vue';
import {Bar} from "vue-chartjs";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";
import {chartColors} from "@/Constants";

export default _defineComponent({
  props: {
    datasets: {type: Array<any>},
    labels: {type: Array<any>},
    displayAxisLabels: {type: Boolean, default: true},
    xLabel: {type: String || null},
    yLabel: {type: String || null},
    id: {type: String},
},
  setup(__props) {

const props = __props
console.log('report:bar:setup')

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const colors = Object.values(chartColors);
const chartData = computed(() => ({
    labels: props.labels,
    datasets: props.datasets.map((dataset: any, index) => (
        { ...dataset, backgroundColor: colors[index], stack: 'a' }
    ))
}));

const chartOptions = {
    responsive: true,
    aspectRatio: 3,
    scales: {
        x: {
            stacked: true,
            title: {
                display: true,
                text: props.xLabel
            }
        },
        y: {
            stacked: true,
            title: {
                display: true,
                text: props.yLabel
            }
        }
    },
}
watch(chartData, x => console.log('report:bar:data', x))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Bar), {
    id: __props.id,
    options: chartOptions,
    data: _unref(chartData)
  }, null, 8, ["id", "data"]))
}
}

})